// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import GeneratingMessage from './GeneratingMessage'
import { success } from 'react-notification-system-redux'

const documentGenerationNotification = jobData => dispatch => {
  const {
    exportJobId,
    jobStatus,
    message,
  } = jobData

  const uid = `document-generation-notification-${exportJobId}`

  const config = {
    uid,
    title: message,
    position: 'br',
    autoDismiss: 0,
    dismissible: false,
    children: (
      <GeneratingMessage
        exportJobId={exportJobId}
        initialJobStatus={jobStatus}
        uid={uid} />
    ),
  }

  dispatch(success(config))
}

export default documentGenerationNotification
